import { Button } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { BodyPartSelector, VERTICAL } from '../move/BodyPartSelector'
import { BODY_PARTS } from '../../../constants'
import { useUnCompleteSubject } from '../../../hooks/useSubject'

type Props = {
  subject: any
  mutateSubjectData: any
  onClose?: () => void
}

export const UnCompleteDrawer = ({ subject, mutateSubjectData, onClose }: Props) => {
  const { projectId } = useParams() as { projectId: string; siteId: string }

  const [uncompleteReason, setUncompleteReason] = useState<string>('')
  const [selectedBodyParts, setSelectedBodyParts] = useState<string>()
  const { callUnComplete, isLoading } = useUnCompleteSubject(projectId, subject._id)

  const currentPhase = subject && subject.currentPhase ? subject.currentPhase : {}

  const confirm = () => {
    const obj = {
      projectId: projectId,
      subjectId: subject._id,
      bodyPart: selectedBodyParts,
      reasonDescription: uncompleteReason,
    }

    return callUnComplete(obj)
      .then((result) => {
        console.log('UnCompleteDrawer > result = ', result)

        mutateSubjectData()
        setUncompleteReason('')
        if (onClose) {
          onClose()
        }

        return result
      })
      .catch((error) => {
        console.log('UnCompleteDrawer > error = ', error)
        return Promise.reject(error)
      })
  }

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setUncompleteReason(e.target.value)
  }

  const plainOptions = currentPhase?.bodyParts
    ? currentPhase.bodyParts.map((item) => {
        return { bodyPart: item, label: BODY_PARTS[item] || item }
      })
    : []

  const hasReason = uncompleteReason.length < 5 ? false : true

  const canMove = selectedBodyParts !== undefined && hasReason

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h5>Revert Study Completion</h5>
        </div>

        {currentPhase?.bodyParts?.length !== 0 ? (
          <>
            <p className="mt-2">
              Revert the study completion and re-activate the subject. This moves the subject to their previous phase
            </p>
            <p className="mt-2">The subject’s device will be re-enabled to continue study participation.</p>

            <p className="fw-bold mt-3 mb-1">Confirm target body part</p>
            <p className="mb-1">Select the target body part and provide a written reason.</p>

            <BodyPartSelector
              bodyparts={plainOptions}
              direction={VERTICAL}
              setSelectedBodyPart={setSelectedBodyParts}
            ></BodyPartSelector>
          </>
        ) : (
          <>
            <p className="mt-2">
              Revert the study completion and re-activate the subject. This moves the subject to their previous phase
            </p>
            <p className="mt-2 mb-3">The subject’s device will be re-enabled to continue study participation.</p>
          </>
        )}
      </div>
      <div>
        <p className="mt-2">Provide justification:</p>
        <TextArea placeholder="" rows={2} className="mt-2" onChange={handleTextChange} />
      </div>
      <div className="mt-3 d-flex justify-content-end">
        <Button onClick={onClose}>Cancel</Button>
        <Button
          className="ms-2"
          type="primary"
          onClick={confirm}
          loading={isLoading}
          disabled={uncompleteReason.length < 5 || plainOptions.length > 0 ? !canMove : false}
        >
          Revert Study Completion
        </Button>
      </div>
    </>
  )
}
